import axios from 'axios';
import { getMicroServiceUrl } from '../helpers/helpers';

export const submitMeterRead = (propertyId, meterReading) => ({
  type: 'SUBMIT_METER_READ',
  payload: axios.post(
    `${getMicroServiceUrl('business-user')}add_meter_reading/${propertyId}/${meterReading}`,
  ),
});

export const getMeterRead = (propertyId) => ({
  type: 'GET_METER_READ',
  payload: axios.get(
    `${getMicroServiceUrl('business-user')}get_meter_readings/${propertyId}`,
  ),
});
